export default function getClosingParams(values, addOpenCloseDateOffPlatformCase) {
  const resolved = values.resolved === 'resolved';
  return { ...values, resolved, addOpenCloseDateOffPlatformCase };
}
